import apiClient from '../lib/apiClient';

const complianceService = {
  // Get all compliance reports with optional filters
  getComplianceReports: async (filters = {}) => {
    try {
      const result = await apiClient.get('/compliance', filters);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch compliance reports' };
    }
  },

  // Get compliance report by ID
  getComplianceReport: async (reportId) => {
    try {
      const result = await apiClient.get(`/compliance/${reportId}`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch compliance report details' };
    }
  },

  // Create new compliance report
  createComplianceReport: async (reportData) => {
    try {
      const result = await apiClient.post('/compliance', reportData);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to create compliance report' };
    }
  },

  // Update compliance report
  updateComplianceReport: async (reportId, updateData) => {
    try {
      const result = await apiClient.put(`/compliance/${reportId}`, updateData);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to update compliance report' };
    }
  },

  // Mark compliance report as filed
  markAsFiled: async (reportId, filingData) => {
    try {
      const result = await apiClient.post('/compliance/markAsFiled', {
        id: reportId,
        ...filingData
      });
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to mark compliance report as filed' };
    }
  },

  // Delete compliance report
  deleteComplianceReport: async (reportId) => {
    try {
      const result = await apiClient.delete(`/compliance/${reportId}`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to delete compliance report' };
    }
  },

  // Get compliance statistics
  getComplianceStats: async () => {
    try {
      const result = await apiClient.get('/compliance/stats');
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch compliance statistics' };
    }
  },

  // Get upcoming deadlines
  getUpcomingDeadlines: async (days = 30) => {
    try {
      const result = await apiClient.get('/compliance/upcoming', { days });
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch upcoming deadlines' };
    }
  },

  // Get compliance calendar data
  getComplianceCalendar: async (month, year) => {
    try {
      const result = await apiClient.get('/compliance/calendar', { month, year });
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch compliance calendar data' };
    }
  },

  // Generate compliance report
  generateReport: async (reportType, dateRange) => {
    try {
      const result = await apiClient.post('/compliance/generate', {
        report_type: reportType,
        date_range: dateRange
      });
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to generate compliance report' };
    }
  }
};

export default complianceService;
